var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-form", staticStyle: { width: "60%" } },
    [
      _c("div", { staticClass: "input-field-container medium" }, [
        _c("div", { staticClass: "input-field-container-bad-label" }, [
          _c("label", { staticClass: "required", attrs: { for: "code" } }, [
            _vm._v(_vm._s(_vm.$tc("Code", 1)) + " *")
          ]),
          _vm._v(" "),
          _vm.checkCode ? _c("p", [_vm._v("Limit is: 32")]) : _vm._e()
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.listValueData.code,
              expression: "listValueData.code"
            }
          ],
          staticClass: "input-field",
          attrs: {
            id: "code",
            type: "text",
            maxlength: "32",
            disabled: _vm.type === "edit"
          },
          domProps: { value: _vm.listValueData.code },
          on: {
            keypress: function($event) {
              return _vm.checkAlphanumeric($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.listValueData, "code", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isCustomList
        ? _c("div", { staticClass: "input-field-container medium" }, [
            _c("label", { attrs: { for: "client_code" } }, [
              _vm._v("\n      " + _vm._s(_vm.$t("ClientCode")) + "\n    ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listValueData.client_code,
                  expression: "listValueData.client_code"
                }
              ],
              staticClass: "input-field",
              attrs: { id: "client_code", maxlength: "3" },
              domProps: { value: _vm.listValueData.client_code },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.listValueData,
                    "client_code",
                    $event.target.value
                  )
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container medium" }, [
        _c("div", { staticClass: "input-field-container-bad-label" }, [
          _c("label", { staticClass: "required", attrs: { for: "Label" } }, [
            _vm._v(_vm._s(_vm.$tc("Label", 1)) + " *")
          ]),
          _vm._v(" "),
          _vm.checkLabel ? _c("p", [_vm._v("Limit is: 255")]) : _vm._e()
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.listValueData.libelle,
              expression: "listValueData.libelle"
            }
          ],
          staticClass: "input-field",
          attrs: {
            id: "label",
            disabled: _vm.type === "edit" && !_vm.isSuperAdmin,
            maxlength: "255"
          },
          domProps: { value: _vm.listValueData.libelle },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.listValueData, "libelle", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isCustomList
        ? _c("div", { staticClass: "input-field-container medium" }, [
            _c("label", { attrs: { for: "client_label" } }, [
              _vm._v("\n      " + _vm._s(_vm.$t("ClientLabel")) + "\n    ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listValueData.client_label,
                  expression: "listValueData.client_label"
                }
              ],
              staticClass: "input-field",
              attrs: { id: "client_label" },
              domProps: { value: _vm.listValueData.client_label },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.listValueData,
                    "client_label",
                    $event.target.value
                  )
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCustomList
        ? _c("div", { staticClass: "input-field-container" }, [
            _c("label", { attrs: { for: "definition" } }, [
              _vm._v(_vm._s(_vm.$t("Definition")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listValueData.definition,
                  expression: "listValueData.definition"
                }
              ],
              staticClass: "input-field",
              attrs: { id: "definition" },
              domProps: { value: _vm.listValueData.definition },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.listValueData, "definition", $event.target.value)
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container medium" }, [
        _c("label", { attrs: { for: "index" } }, [
          _vm._v("\n      " + _vm._s(_vm.$t("Index")) + "\n    ")
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.listValueData.index,
              expression: "listValueData.index"
            }
          ],
          staticClass: "input-field",
          attrs: { id: "index", type: "number", min: "0" },
          domProps: { value: _vm.listValueData.index },
          on: {
            keypress: function($event) {
              return _vm.checkInteger($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.listValueData, "index", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container medium" }),
      _vm._v(" "),
      !_vm.isCustomList
        ? _c(
            "div",
            { staticClass: "input-field-container medium radio-container" },
            [
              _c("label", { attrs: { for: "status" } }, [
                _vm._v("\n      " + _vm._s(_vm.$t("Blocked")) + "\n    ")
              ]),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: {
                    id: "status",
                    mandatory: true,
                    row: true,
                    disabled: !_vm.isSuperAdmin
                  },
                  model: {
                    value: _vm.listValueData.blocked,
                    callback: function($$v) {
                      _vm.$set(_vm.listValueData, "blocked", $$v)
                    },
                    expression: "listValueData.blocked"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t("Yes"),
                      value: true,
                      ripple: false,
                      color: "accent"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t("No"),
                      value: false,
                      ripple: false,
                      color: "accent"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCustomList
        ? _c(
            "div",
            { staticClass: "input-field-container medium radio-container" },
            [
              _c("label", { attrs: { for: "deleted" } }, [
                _vm._v("\n      " + _vm._s(_vm.$t("Hidden")) + "\n    ")
              ]),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: {
                    id: "deleted",
                    disabled: !_vm.isSuperAdmin && !_vm.isAdmin,
                    mandatory: "",
                    row: ""
                  },
                  model: {
                    value: _vm.listValueData.deleted,
                    callback: function($$v) {
                      _vm.$set(_vm.listValueData, "deleted", $$v)
                    },
                    expression: "listValueData.deleted"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t("Yes"),
                      value: true,
                      ripple: false,
                      color: "accent"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t("No"),
                      value: false,
                      ripple: false,
                      color: "accent"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-706efbc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-706efbc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListItemForm.vue
// module id = null
// module chunks = 